/**
 * GA4 Product Page Events
 * selectSize, SelectCustomSize, SysVirtualTryOnButtonLoaded,
 * ClickVirtualTryOnButton, ClickAddQuantity, ClickAddToCart,
 * ClickAddToCartOnCustomSizeModal, ClickBuyItNow
 * Only runs on product pages.
 */

(function () {
  const gtag = window.trovelle?.ga4?.gtag;
  const measurementId = window.trovelle?.ga4?.measurementId;
  if (!gtag || !measurementId) return;

  const route = window.trovelle?.ga4?.route?.getRoute?.();
  if (route?.type !== 'product') return;

  function getProductData() {
    const section = document.querySelector('.product-information[data-ga4-product-id]');
    const parsePrice = (v) => {
      const n = typeof v === 'string' ? parseFloat(v) : Number(v);
      return isNaN(n) ? 0 : n / 100;
    };
    return {
      product_id: section?.getAttribute('data-ga4-product-id') || '',
      title: section?.getAttribute('data-ga4-product-title') || document.title || '',
      vendor_id: section?.getAttribute('data-ga4-product-vendor') || '',
      vendor_name: section?.getAttribute('data-ga4-product-vendor') || '',
      sku_id: section?.getAttribute('data-ga4-product-sku') || '',
      product_type: section?.getAttribute('data-ga4-product-type') || '',
      price: parsePrice(section?.getAttribute('data-ga4-product-price')),
      color: section?.getAttribute('data-ga4-product-color') || '',
      fit: section?.getAttribute('data-ga4-product-fit') || '',
      composition: section?.getAttribute('data-ga4-product-composition') || '',
      page_location: window.location.href,
      page_title: document.title || '',
      collection_name: section?.getAttribute('data-ga4-collection-name') || '',
    };
  }

  function isSizeOption(optionName) {
    if (!optionName) return false;
    const n = String(optionName).toLowerCase();
    return n.includes('size') || n === 'size';
  }

  function isCustomValue(value) {
    if (!value) return false;
    const v = String(value).toLowerCase();
    return v === 'custom';
  }

  function init() {
    document.addEventListener('change', (e) => {
      const target = e.target;
      const picker = target.closest('variant-picker');
      if (!picker) return;
      if (!picker.closest('.product-information')) return;

      const optionContainer = target.closest('.variant-option');
      const optionName = optionContainer?.getAttribute?.('data-option-name') || optionContainer?.querySelector?.('legend')?.textContent?.trim()?.split(/\s/)[0] || '';
      const value = target.value?.trim() || (target instanceof HTMLSelectElement ? target.options[target.selectedIndex]?.value : '');

      if (isCustomValue(value)) {
        gtag('event', 'SelectCustomSize', getProductData());
        return;
      }

      if (isSizeOption(optionName)) {
        gtag('event', 'selectSize', {
          ...getProductData(),
          selectedSize: value,
        });
      }
    }, true);

    document.addEventListener('quantity-selector:update', (e) => {
      if (!e.detail) return;
      const selector = e.target?.closest?.('quantity-selector-component');
      if (!selector) return;
      if (!selector.closest('.product-information')) return;
      if (e.detail.cartLine != null && !isNaN(e.detail.cartLine)) return;
      gtag('event', 'ClickAddQuantity', getProductData());
    }, true);

    document.addEventListener('click', (e) => {
      const target = e.target;
      if (!(target instanceof Element)) return;

      if (target.closest('#icona-virual-try-on')) {
        gtag('event', 'ClickVirtualTryOnButton', getProductData());
        return;
      }

      if (target.closest('.cs-modal__atc')) {
        const modal = target.closest('.cs-modal');
        const form = modal?.querySelector('.cs-modal__form');
        const formValues = /** @type {Record<string, string>} */ ({});
        if (form) {
          form.querySelectorAll('input, select, textarea').forEach((el) => {
            if (el instanceof HTMLInputElement || el instanceof HTMLSelectElement || el instanceof HTMLTextAreaElement) {
              if (el.name) formValues[el.name] = el.value ?? '';
            }
          });
        }
        gtag('event', 'ClickAddToCartOnCustomSizeModal', {
          ...getProductData(),
          form_values: formValues,
        });
        return;
      }

      const addToCartBtn = target.closest('add-to-cart-component button[type="submit"], .add-to-cart-button');
      if (addToCartBtn && addToCartBtn.closest('.product-information') && !addToCartBtn.closest('.cs-modal')) {
        gtag('event', 'ClickAddToCart', getProductData());
        return;
      }

      if (target.closest('.accelerated-checkout-block') && target.closest('button, a, [role="button"]')) {
        gtag('event', 'ClickBuyItNow', getProductData());
      }
    }, true);

    let vtoFired = false;
    const vtoCheckInterval = setInterval(() => {
      if (vtoFired) {
        clearInterval(vtoCheckInterval);
        return;
      }
      const vto = document.getElementById('icona-virual-try-on');
      if (vto) {
        vtoFired = true;
        clearInterval(vtoCheckInterval);
        gtag('event', 'SysVirtualTryOnButtonLoaded', getProductData());
      }
    }, 100);

    setTimeout(() => {
      clearInterval(vtoCheckInterval);
    }, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
